import React, { Component, useState, useRef } from "react";
import "react-table/react-table.css";
import { withStore } from "../store";
import { Service } from "../ApiService";
import ReactTable from "react-table";
import Table from "react-table";
import Alert from "../Alert";
import Loader from "../Loader";
import CheckBox from "../CheckBox";
import SaveToExcelSVG from "../../svg/SaveToExcelSVG";
import "./report.css";
import ChapterRequirement from "./ChapterRequirement";

const getTrProps = (state, rowInfo, instance) => {
  if (rowInfo) {
    return {
      style: {
        "background-color":
          rowInfo.original.isGoldenPaddle === true
            ? ""
            : "rgba(255, 151, 151, .5)",
      },
    };
  }
  return {};
};

const TableHeader = ({ name }) => {
  return <strong style={{ color: "#00008B" }}>{name}</strong>;
};

const columns = [
  { Header: "Chapter", accessor: "chapterName" },
  { Header: "State", accessor: "state" },
  { Header: "# Of On-Water Events", accessor: "onWaterEvents" },
  { Header: "# Of Valid On-Water Events", accessor: "validOnWaterEvents" },
  { Header: "# Unique Veterans", accessor: "uniqueVeterans" },
  { Header: "Safety Stand Down Meeting", accessor: "safetyStandDown" },
];

const styleCell = (row, accessor, filters) => {
  let className = "";

  if (
    (accessor === "onWaterEvents" &&
      row.onWaterEvents < filters.OnWaterEvents) ||
    (accessor === "validOnWaterEvents" &&
      row.validOnWaterEvents < filters.OnWaterEvents) ||
    (accessor === "uniqueVeterans" &&
      row.uniqueVeterans < filters.UniqueVeterans) ||
    (accessor === "safetyStandDown" &&
      filters.SafetyMeeting &&
      !row.SafetyMeeting)
  ) {
    className = "boldedCell";
  }
  return <div className={className}>{row[accessor]}</div>;
};

class GoldenPaddle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: false,
      columns: columns.map((col) => {
        return {
          Header: <TableHeader name={col.Header} />,
          accessor: col.accessor,
          Cell: (props) => {
              return styleCell(props.row, col.accessor, this.state.ranFilters);
          },
        };
      }),
      filters: {
        Chapter: [],
        OnWaterEvents: 25,
        VeteransPerEvents: 2,
        UniqueVeterans: 15,
        SafetyMeeting: true,
        Year: 2023,
        ShowEligible: true,
        ShowNotEligible: true,
      },
      ranFilters: {
        Chapter: [],
        OnWaterEvents: 25,
        VeteransPerEvents: 2,
        UniqueVeterans: 15,
        SafetyMeeting: true,
        Year: 2023,
        ShowEligible: true,
        ShowNotEligible: true,
      },
    };
    this.reactTable = null;
  }
  downloadExcel() {
    this.setState({ loading: true });
    Service.downloadWithPost(
      "/api/Reports/GoldenPaddleToExcel",
      this.state.filters,
    ).then((blob) => {
      Service.throwBlob(blob, "GoldenPaddle.xlsx");
      this.setState({ loading: false });
    });
  }
  runReport() {
    this.setState({ loading: true });
    Service.getGoldenPaddleReport(this.state.filters)
      .then((response) => {
        this.setState({ data: response });
        this.setState({ loading: false });
        this.setState({ranFilters: {...this.state.filters}})
      })
      .catch((err) => this.setState({ loading: false }));
  }
  validCount(data) {
    let validGoldenPaddle = 0;
    data.forEach(elem => {
      if(elem.isGoldenPaddle) {
        validGoldenPaddle++;
      }
    })
    return validGoldenPaddle;
  }

  render() {
    return (
      <div>
        {this.state.loading && <Loader />}
        <div className="filter-nav-wrapper">
          <div className="filter-wrapper"></div>
          <button
            className="round-button medium-round-button outline-on-hover"
            onClick={() => this.downloadExcel()}
          >
            <SaveToExcelSVG />
            <span>Excel</span>
          </button>
        </div>
        <h3 className="mr-05 ml-05 mt-2 mb-2 uppercase-text">
          <strong>Golden Paddle</strong> Report
        </h3>
        <div className="p-24 pl-2">
          <p className="max-w-full chapterMatches">Chapter Matches: {this.validCount(this.state.data)}</p>
          <h4 className="chapterRequirementsHeader">Chapter Requirements</h4>
          <p className="italicsText">
            # Refers to Minimum Criteria for Golden Paddle Qualifications
          </p>
          {/* component here */}
          <div className="chapterRequirementFields">
            <ChapterRequirement
              label={"# Of On-Water Events"}
              onChange={(e) =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    OnWaterEvents: e.target.value,
                  },
                })
              }
              defaultValue={25}
            />
            <ChapterRequirement
              label={"# Of Veterans per On-Water Event"}
              onChange={(e) =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    VeteransPerEvents: e.target.value,
                  },
                })
              }
              defaultValue={2}
            />
            <ChapterRequirement
              label={"# Of Unique Veterans"}
              onChange={(e) =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    UniqueVeterans: e.target.value,
                  },
                })
              }
              defaultValue={15}
            />
            <div className="selectionFilterWrapper yearFilterWrapper">
              <div className="selectionFilterLabel yearLabel">Year</div>
              <input
                className="inputField yearInput"
                type="number"
                onChange={(e) =>
                  this.setState({
                    filters: {
                      ...this.state.filters,
                      Year: e.target.value,
                    },
                  })
                }
                defaultValue={2023}
              />
            </div>
          </div>
          <CheckBox
            className="italicsText"
            style={{ marginTop: "0.6rem" }}
            onClick={() => {
              this.setState({
                filters: {
                  ...this.state.filters,
                  SafetyMeeting: !this.state.filters.SafetyMeeting,
                },
              });
            }}
            checked={this.state.filters.SafetyMeeting}
            labelClassName="uppercase-text bold-text"
            labelText="Completed Safety Stand Down Meeting"
          />
          <div className="flex-nowrap">
            <div class="reportButton" onClick={() => this.runReport()}>
              Run Report
            </div>
            <div className="flex-wrap pl-2">
              <CheckBox
                labelClassName="uppercase-text bold-text"
                labelText="Show eligible chapters"
                onClick={() => {
                  this.setState({
                    filters: {
                      ...this.state.filters,
                      ShowEligible: !this.state.filters.ShowEligible,
                    },
                  });
                }}
                checked={this.state.filters.ShowEligible}
              />
            </div>
            <div className="flex-wrap pl-2">
              <CheckBox
                labelClassName="uppercase-text bold-text"
                labelText="Show ineligible chapters"
                onClick={() => {
                  this.setState({
                    filters: {
                      ...this.state.filters,
                      ShowNotEligible: !this.state.filters.ShowNotEligible,
                    },
                  });
                }}
                checked={this.state.filters.ShowNotEligible}
              />
            </div>
          </div>
        </div>
        <div>
          <Table
            data={this.state.data}
            columns={this.state.columns}
            defaultPageSize={20}
            getTrProps={getTrProps}
          />
        </div>
      </div>
    );
  }
}
export default withStore(GoldenPaddle);



// WEBPACK FOOTER //
// ./src/components/reports/GoldenPaddle.jsx